<button type="button" mat-icon-button class="history-trigger" [matMenuTriggerFor]="menu">
  <lib-tess-icon class="history-icon" icon="mdi:history" />
</button>
<mat-menu #menu="matMenu" class="toolbar-menu">
  @for (option of options; track option.title) {
    <div (click)="navigate(option.routeName)" (keypress.enter)="navigate(option.routeName)" tabindex="0" class="link-option">
      <div class="option-title">{{ option.title }}</div>
    </div>
  }
</mat-menu>
